// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"390":"ef3db169","643":"64376f81"}[chunkId] + ".chunk.css";
};